import { z } from 'zod';

import { useStore } from '../../store';

const TableauTokenResponse = z.object({
  tableau_token: z.string(),
});

export type TableauTokenResponse = z.infer<typeof TableauTokenResponse>;

export async function getTableauToken(): Promise<TableauTokenResponse> {
  try {
    const { session } = useStore.getState();

    const response = await session
      ?.getPortalApiClient()
      ?.untyped.GET('/api/v1/tableau/token', {});
    return TableauTokenResponse.parse(response?.data);
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
}
